'use client';

import { getLexicalChildrenText, hasVisibleText } from '@/lib/heading.utils';
import { cn } from '@/lib/utils';

interface ContentNavigationProps {
  article?: {
    content?: {
      root?: {
        children?: Array<{ type?: string; children?: unknown[] }>;
      };
    };
  };
  className?: string;
}
const getVisibleHeadings = (article: ContentNavigationProps['article']) =>
  article?.content?.root?.children?.filter(
    (child: { type?: string; children?: unknown[] }) =>
      child.type === 'heading' && hasVisibleText(getLexicalChildrenText(child.children)),
  ) ?? [];

export const ContentNavigation = ({ article, className }: ContentNavigationProps) => {
  const visibleHeadings = getVisibleHeadings(article);

  if (visibleHeadings.length === 0) return null;

  return (
    <div className={cn('', className)}>
      <div className="lg:sticky lg:top-4">
        <p className="text-[#C0C3D3] text-sm border-b border-[#F7F7F7] pb-3">Содержание</p>
        <div className="grid divide-y divide-[#F7F7F7]">
          {visibleHeadings.map((child: { children?: unknown[] }, index: number) => {
            const headingText = getLexicalChildrenText(child.children).trim();

            return (
              <div
                key={`${headingText}-${index}`}
                className="py-3 cursor-pointer text-[#575E74] hover:text-[#1B1D22] text-sm leading-[92%] font-medium"
                onClick={() => {
                  const element = document.getElementById(headingText);
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                {index + 1}. {headingText}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
